exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-fathersday-rule .main[data-v-7b62dbda] {\n  background: #fff;\n  border-radius: 8px;\n}\n.page-fathersday-rule .main h3[data-v-7b62dbda] {\n  padding: 10px 0;\n  text-align: center;\n  border-bottom: 5px solid #cce0fc;\n  color: #454545;\n}\n.page-fathersday-rule .main .content[data-v-7b62dbda] {\n  padding: 20px;\n}\n", ""]);

// exports
